import * as React from 'react';
import MInproductionView from '../layouts/MInproductionView';
// import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { TatData } from 'src/reducers/fileUpload';
import { RowDataManufactur } from 'src/reducers/manufactur';
import { RedesignReasons } from 'src/reducers/completeorderfile';
// import { UserDetail } from '../../reducers/user';

export interface MInproductionViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    mInproductionData: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: () => void;
    onBulkDownloadStl: () => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;

    caseFilter: (fcaseno: string, tcaseno: string, status: string) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
}

class MInproductionPage extends React.Component<MInproductionViewProps> {
    render() {
        return (
            <MInproductionView
                mInproductionData={this.props.mInproductionData}
                isDownloading={this.props.isDownloading}
                redesignReasons={this.props.redesignReasons}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onDownloadClick={this.props.onDownloadClick}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                fromDate={this.props.fromDate}
                toDate={this.props.toDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                orderDataTat={this.props.orderDataTat}
                approvalRequired={this.props.approvalRequired}
                redesignRequest={this.props.redesignRequest}
                caseFilter={this.props.caseFilter}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default MInproductionPage;



// WEBPACK FOOTER //
// ./src/components/MInproduction/MInproductionPage.tsx